const floatieGatewayOracleAbi = [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "authorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address payable",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract FloatieGateway",
				"name": "_floatieGateway",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "unauthorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "floatieGateway",
		"outputs": [
			{
				"internalType": "contract FloatieGateway",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			}
		],
		"name": "getAllowRocketPlayOnSell",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			}
		],
		"name": "getAllTokenomics",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "sell",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "buy",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "transfer",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "stake",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "burn",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "unstake",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fund",
						"type": "uint256"
					}
				],
				"internalType": "struct FloatieGatewayOracle.Tokenomics",
				"name": "tokenomics",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			}
		],
		"name": "getETHFeeDistribution",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint16",
						"name": "otherTeam",
						"type": "uint16"
					},
					{
						"internalType": "uint16",
						"name": "marketing",
						"type": "uint16"
					},
					{
						"internalType": "uint16",
						"name": "rewardPackAll",
						"type": "uint16"
					},
					{
						"internalType": "uint16",
						"name": "rewardPack",
						"type": "uint16"
					}
				],
				"internalType": "struct FloatieGatewayOracle.ETHFeeDistribution",
				"name": "ethFeeDistributions",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			}
		],
		"name": "getFeeDistribution",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint16",
						"name": "otherTeam",
						"type": "uint16"
					},
					{
						"internalType": "uint16",
						"name": "marketing",
						"type": "uint16"
					},
					{
						"internalType": "uint16",
						"name": "rocketPlay",
						"type": "uint16"
					},
					{
						"internalType": "uint16",
						"name": "staking",
						"type": "uint16"
					},
					{
						"internalType": "uint16",
						"name": "burnToEarn",
						"type": "uint16"
					},
					{
						"internalType": "uint16",
						"name": "fundToEarn",
						"type": "uint16"
					}
				],
				"internalType": "struct FloatieGatewayOracle.FeeDistribution",
				"name": "feeDistributions",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getFundedBalance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "funded",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getStakedBalance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "staked",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "isAuthorized",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "isOwner",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];

export default floatieGatewayOracleAbi;